/** Queries that show suggestions or activity and should refresh after a chat turn. */
export const WORKBENCH_REFETCH_QUERIES = [
  "WorkbenchFeature",
  "WorkbenchSuggestionsByFlag",
  "WorkbenchChangeRequestStatus",
  "WorkbenchFeatureList",
  "WorkbenchReviewSummaries",
];
